/**
 * Expedientes Service (credit-engine-business)
 * API Gateway path: /credit/v2/backoffice/customer-files
 * Endpoints for P10 — cliente file view (backoffice only).
 */

import { apiGet } from '@/lib/axios';
import type {
  ExpedienteSearchItem,
  ExpedienteResumenResponse,
  ExpedienteIdentityResponse,
  ExpedienteAuditLogResponse,
  ExpedienteMessagesResponse,
} from '@/types/expedientes.types';

// RBAC v2: /credit/v2/backoffice/customer-files/* (W4 + @RequirePermission).
const BASE = '/credit/v2/backoffice/customer-files';

/**
 * GET /credit/v2/backoffice/customer-files/search?q=&partnerId=
 * Busca por telefono, directoryId (UUID) o peopleId.
 */
export const searchExpedientes = (q: string, partnerId: string) =>
  apiGet<ExpedienteSearchItem[]>(`${BASE}/search`, { params: { q, partnerId } });

/**
 * GET /credit/v2/backoffice/customer-files/{directoryId}/summary?partnerId=
 * Pantalla principal del expediente (header + estado general).
 */
export const getExpedienteResumen = (directoryId: string, partnerId: string) =>
  apiGet<ExpedienteResumenResponse>(`${BASE}/${directoryId}/summary`, { params: { partnerId } });

/**
 * GET /credit/v2/backoffice/customer-files/{directoryId}/identity?partnerId=
 * Sección Identidad (§4.2): people + OCR + signed URLs + score anti-fraude.
 */
export const getExpedienteIdentity = (directoryId: string, partnerId: string) =>
  apiGet<ExpedienteIdentityResponse>(`${BASE}/${directoryId}/identity`, { params: { partnerId } });

/**
 * GET /credit/v2/backoffice/customer-files/{directoryId}/audit-log?partnerId=&page=&page_size=
 * Historial paginado de accesos al expediente (§4.8).
 */
export const getExpedienteAuditLog = (directoryId: string, partnerId: string, page: number, pageSize: number) =>
  apiGet<ExpedienteAuditLogResponse>(`${BASE}/${directoryId}/audit-log`, {
    params: { partnerId, page, page_size: pageSize },
  });

export interface MessagesQueryParams {
  from?: number;
  to?: number;
  category?: 'credit' | 'other' | 'all';
  subCategory?: string;   // csv
  cursor?: string;
  pageSize?: number;
}

/**
 * GET /credit/v2/backoffice/customer-files/{directoryId}/messages
 * Historico de push notifications al cliente con clasificacion y correlacion.
 */
export const getExpedienteMessages = (
  directoryId: string,
  partnerId: string,
  params: MessagesQueryParams,
) =>
  apiGet<ExpedienteMessagesResponse>(`${BASE}/${directoryId}/messages`, {
    params: {
      partnerId,
      from: params.from,
      to: params.to,
      category: params.category,
      subCategory: params.subCategory,
      cursor: params.cursor,
      pageSize: params.pageSize,
    },
  });
